const key = () => `watch-history:${localStorage.getItem("token") || "guest"}`;
export function readHistory() {
  try { const value = JSON.parse(localStorage.getItem(key()) || "[]"); return Array.isArray(value) ? value : []; }
  catch (error) { return []; }
}
export function saveHistory(item) {
  if (!item || !item.id) return;
  try {
    const history = readHistory().filter(old => String(old.id) !== String(item.id));
    localStorage.setItem(key(), JSON.stringify([item].concat(history).slice(0, 50)));
  } catch (error) { /* Browsing is still available when local storage is full or disabled. */ }
}
